import * as React from 'react';

const AccessRight = ({ user }) => {
  const renderFlag = (bool) =>
    bool ? (
      <i className="fas fa-check" style={{ color: 'green' }}></i>
    ) : (
      <i className="fas fa-times" style={{ color: 'red' }}></i>
    );

  return (
    <>
      <div className="mt-3">User Info:</div>
      <div className="p-4 mt-2 card d-flex flex-column w-100">
        <div>
          <span className="fw-bold">Role: </span>
          {user.role}
        </div>
        <div>
          <span className="fw-bold">Profession: </span>
          {user.profession}
        </div>
        <div>
          <span className="fw-bold">Member Type: </span>
          {user.memberType}
        </div>
      </div>

      <div className="mt-3">Event Access Rights:</div>
      <div className="p-4 mt-2 card d-flex flex-column w-100">
        <div>
          {user.eventAccess?.map((event, index) => (
            <div key={index}>
              <span className="fw-bold">{`${event}: `}</span>
              {renderFlag(event)}
            </div>
          ))}
        </div>

        <div>
          {user.wskAccess?.map((wsk, index) => (
            <div key={index}>
              <span className="fw-bold">{`WSK ${index + 1}: `}</span>
              {renderFlag(wsk)}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-3">Abstracts Info:</div>
      <div className="p-4 mt-2 card w-100">
        <div className="mb-1">
          <span className="fw-bold">Is Lighting Presenter?&nbsp;</span>
          {renderFlag(user.isOralPresenter)}
        </div>
        <small
          className="d-block"
          dangerouslySetInnerHTML={{ __html: user.oralAbs }}
        />

        <hr />

        <div className="mb-1">
          <span className="fw-bold">Is Winner?&nbsp;</span>
          {renderFlag(user.isAwardWinner)}
        </div>
        <small
          className="d-block"
          dangerouslySetInnerHTML={{ __html: user.winnerAbs }}
        />
      </div>

      {/* <hr />
        <div className="mb-1">
          <span className="fw-bold">Is Finalist?&nbsp;</span>
          {renderFlag(user.isFinalist)}
        </div>
        <small
          className="d-block"
          dangerouslySetInnerHTML={{ __html: user.finalistAbs }}
        />
        <div className="mt-1">
          <small>
            <strong>Award Type:</strong> {user.finalistType}
          </small>
        </div> */}
    </>
  );
};

export default AccessRight;
